import { uiBase } from '../env/constants'

export const maskURL  = uiBase +'em'
export const sheetURL = uiBase +'ts'
